import produce from 'immer'

import {
  DESIGN_MATCHES_LOAD,
  DESIGN_MATCHES_LOAD_SUCCESS,
  DESIGN_MATCHES_LOAD_FAILURE
} from './actions'
import { DesignMatchRow } from './types'

interface DesignMatchesState {
  loading: boolean
  error: null | string
  items: DesignMatchRow[]
  totalCount: number
  hasNextPage: boolean
}

const initialState: DesignMatchesState = {
  loading: false,
  error: null,
  items: [],
  totalCount: 0,
  hasNextPage: false
}

export const reducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case DESIGN_MATCHES_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case DESIGN_MATCHES_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.items = action.items
        draft.totalCount = action.totalCount
        draft.hasNextPage = action.hasNextPage
        return
      }
      case DESIGN_MATCHES_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
